var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 16.8766C2.87101 16.8767 4.08519 16.6808 5.24183 16.2969",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3127 3.15977C12.0636 2.31849 11.7093 1.50989 11.2578 0.751953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8543 16.8755C20.2426 15.8503 19.4603 14.9302 18.5391 14.1523",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8505 6.12695C19.6281 6.12715 18.4142 6.32328 17.2578 6.70741",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 19.8438C10.4522 20.685 10.8065 21.4936 11.258 22.2516",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 6.12695C2.26011 7.15195 3.04213 8.07203 3.96296 8.85008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2544 16.8744C11.741 16.0574 11.9972 15.1306 11.9972 14.1871C11.9972 13.2437 11.741 12.3169 11.2544 11.4999C10.7679 10.6828 10.068 10.0043 9.22518 9.53261C8.38237 9.06088 7.42633 8.81252 6.45312 8.8125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45312 14.1888C7.42633 14.1888 8.38237 13.9405 9.22518 13.4687C10.068 12.997 10.7679 12.3185 11.2544 11.5015C11.741 10.6844 11.9972 9.75764 11.9972 8.81421C11.9972 7.87079 11.741 6.94398 11.2544 6.12695",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2335 8.21563C19.8613 7.58584 20.4075 6.8841 20.8598 6.12599C19.6213 4.55979 17.8375 3.48363 15.841 3.09811C13.8445 2.71259 11.7715 3.04401 10.0084 4.03061C8.24531 5.01721 6.91247 6.59165 6.25833 8.46045C5.60419 10.3292 5.67338 12.3649 6.453 14.1879C6.93962 13.3709 7.63951 12.6925 8.4823 12.2208C9.3251 11.7491 10.2811 11.5008 11.2543 11.5008C12.2275 11.5008 13.1835 11.7491 14.0263 12.2208C14.8691 12.6925 15.569 13.3709 16.0556 14.1879C14.816 15.7513 13.0328 16.8248 11.0376 17.2087C9.0425 17.5926 6.97144 17.2607 5.20992 16.2748C3.44839 15.2889 2.11639 13.7161 1.46184 11.8491C0.807285 9.98219 0.874762 7.9483 1.65171 6.12599C2.55399 6.12608 3.45289 6.23293 4.32846 6.44417",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1754 16.5589C19.0517 16.7703 19.9513 16.8772 20.8543 16.8771C21.6319 15.0546 21.6998 13.0203 21.0454 11.1529C20.3909 9.2855 19.0587 7.71229 17.2968 6.7262C15.5349 5.7401 13.4634 5.40831 11.4679 5.79262C9.47242 6.17692 7.68901 7.25112 6.44973 8.81522C6.93635 9.6322 7.63623 10.3106 8.47903 10.7823C9.32183 11.254 10.2778 11.5023 11.251 11.5023C12.2242 11.5023 13.1802 11.254 14.023 10.7823C14.8658 10.3106 15.5657 9.6322 16.0523 8.81522C16.8293 10.6375 16.8967 12.6714 16.2422 14.5384C15.5876 16.4053 14.2556 17.9781 12.4941 18.964C10.7326 19.95 8.66151 20.2819 6.66638 19.898C4.67126 19.5141 2.88797 18.4405 1.64844 16.8771C2.10077 16.119 2.64691 15.4172 3.27474 14.7875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5295 18.9443C12.2942 20.1073 11.8621 21.2245 11.2506 22.2507C13.2673 21.9921 15.1184 21.0319 16.4592 19.5488C17.8001 18.0658 18.5393 16.1609 18.5393 14.1888C18.5393 12.2168 17.8001 10.3119 16.4592 8.82885C15.1184 7.34578 13.2673 6.38556 11.2506 6.12695C10.764 6.94398 10.5078 7.87079 10.5078 8.81421C10.5078 9.75764 10.764 10.6844 11.2506 11.5015C11.7372 12.3185 12.437 12.997 13.2798 13.4687C14.1226 13.9405 15.0787 14.1888 16.0519 14.1888",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97149 4.05912C10.2064 2.89593 10.6383 1.77845 11.2496 0.751953C9.23289 1.01056 7.38182 1.97078 6.04099 3.45385C4.70016 4.93692 3.96094 6.84179 3.96094 8.81384C3.96094 10.7859 4.70016 12.6908 6.04099 14.1738C7.38182 15.6569 9.23289 16.6171 11.2496 16.8757C10.763 16.0587 10.5068 15.1319 10.5068 14.1885C10.5068 13.245 10.763 12.3182 11.2496 11.5012C11.7362 10.6842 12.436 10.0057 13.2788 9.53395C14.1217 9.06222 15.0777 8.81387 16.0509 8.81384",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLight);
export default __webpack_public_path__ + "static/media/AI-light.f5bfbe9999a3ffbe9e710d7ea4715281.svg";
export { ForwardRef as ReactComponent };